import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutocompleteComponent } from '../../../../common/autocomplete/autocomplete.component';
import { BaseComponent } from '../../../../common/base.component';
import { Rarity, JewelType } from '../../../../models/enums';
import { AdvancedEquipmentConditions, GearHighlightConfig, JewelFilter } from '../../../../models/filter-models';
import { BaseType } from '../../../../models/item-data-models';
import { FilterService } from '../../../../services/filter.service';
import { AdvancedEquipmentConditionsComponent } from '../../advanced-equipment-conditions/advanced-equipment-conditions.component';
import { MyEquipmentHighlightsComponent } from '../../my-equipment-highlights/my-equipment-highlights.component';
import { SelectRarityComponent } from '../../../../common/select/select-rarity/select-rarity.component';
import { TooltipWrapperComponent } from '../../../../common/tooltip-wrapper/tooltip-wrapper.component';

@Component({
  selector: 'app-jewel-filter',
  imports: [FormsModule, AutocompleteComponent, SelectRarityComponent, AdvancedEquipmentConditionsComponent, MyEquipmentHighlightsComponent,
    TooltipWrapperComponent],
  templateUrl: './jewel-filter.component.html',
  styleUrl: './jewel-filter.component.scss'
})
export class JewelFilterComponent extends BaseComponent implements OnInit {
  @Input({ required: true }) jewel!: JewelFilter;
  @Input({ required: true }) index!: number;
  @Output() remove = new EventEmitter<number>();

  hasAdvancedConditions = 0;
  advancedConditionsOpen = false;
  hasHighlightConfig = 0;
  highlightConfigOpen = false;

  jewelTypes: BaseType[] = [];

  constructor(private filterService: FilterService) {
    super();

    this.jewelTypes = this.poe2 ? [
      { name: 'Emerald', image: '/img/gear/jewels/emeraldjewel.webp' },
      { name: 'Ruby', image: '/img/gear/jewels/rubyjewel.webp' },
      { name: 'Sapphire', image: '/img/gear/jewels/sapphirejewel.webp' },
      { name: 'Diamond', image: '/img/gear/jewels/diamondjewel.webp' },
      { name: 'Time-Lost Emerald', image: '/img/gear/jewels/specialemeraldjewel.webp' },
      { name: 'Time-Lost Ruby', image: '/img/gear/jewels/specialrubyjewel.webp' },
      { name: 'Time-Lost Sapphire', image: '/img/gear/jewels/specialsapphirejewel.webp' },
      { name: 'Time-Lost Diamond', image: '/img/gear/jewels/timelostdiamondjewel.webp' },
    ] : [
      { name: 'Crimson Jewel', image: '/img/gear/jewels/basicstr.webp' }, // TODO POE1 : correct image urls
      { name: 'Viridian Jewel', image: '/img/gear/jewels/basicdex.webp' },
      { name: 'Cobalt Jewel', image: '/img/gear/jewels/basicint.webp' },

      { name: 'Large Cluster Jewel', image: '/img/gear/jewels/newgembase3.webp' },
      { name: 'Medium Cluster Jewel', image: '/img/gear/jewels/newgembase2.webp' },
      { name: 'Small Cluster Jewel', image: '/img/gear/jewels/newgembase1.webp' },

      { name: 'Murderous Eye Jewel', image: '/img/gear/jewels/murderouseye.webp' },
      { name: 'Searching Eye Jewel', image: '/img/gear/jewels/searchingeye.webp' },
      { name: 'Hypnotic Eye Jewel', image: '/img/gear/jewels/rivetedeye.webp' },
      { name: 'Ghastly Eye Jewel', image: '/img/gear/jewels/ghastlyeye.webp' },
    ];
  }

  ngOnInit(): void {
    this.hasAdvancedConditions = this.getNumberOfAdvancedConditions();
    this.hasHighlightConfig = this.getNumberOfHighlightConfig();
  }

  toggleAdvancedOptionsOpen() {
    this.advancedConditionsOpen = !this.advancedConditionsOpen;
  }

  toggleHighlightConfigOpen() {
    this.highlightConfigOpen = !this.highlightConfigOpen;
  }

  getNumberOfAdvancedConditions() {
    return AdvancedEquipmentConditions.hasChanges(this.jewel);
  }

  getNumberOfHighlightConfig() {
    return GearHighlightConfig.hasChanges(this.jewel.highlightConfig);
  }

  toggleShowJewel() {
    this.jewel.show = !this.jewel.show;
    if (!this.jewel.show) {
      this.advancedConditionsOpen = false;
      this.highlightConfigOpen = false;
    }
    this.updateFilter();
  }

  removeJewelType() {
    this.remove.emit(this.index);
  }

  jewelTypeChanged(jewelTypes: string[]) {
    this.jewel.jewelType = jewelTypes.map(j => j as JewelType);
    this.updateFilter();
  }

  minRarityChanged(rarity: Rarity) {
    if (this.jewel.rarity === Rarity.Magic) {
      this.jewel.highlightConfig.regularMagic = true;
    }

    if (this.jewel.rarity === Rarity.Rare) {
      this.jewel.highlightConfig.regularMagic = false;
    }

    this.hasHighlightConfig = this.getNumberOfHighlightConfig();
    this.updateFilter();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
